export const tableHeader = {
  'Date/time': 'payoutDate',
  'Transaction ID': 'stripeTransactionId',
  'Earned Income': 'totalEarnings',
  'Transfer Fee': 'totalTransferFees',
  'Bank Fees': 'totalBankFees',
  'Payout Amt': 'totalPayout',
};
